module.exports = __webpack_public_path__ + "linea-basic-10.61f3a8a387a64abfc053.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/linea/fonts/linea-basic-10.woff
// module id = ../../../../../src/assets/linea/fonts/linea-basic-10.woff
// module chunks = styles